import { ResourceProps } from '@refinedev/core';

export const resources: ResourceProps[] = [
  {
    name: 'devices',
    list: '/devices',
    show: '/devices/:imei',
    meta: {
      label: 'resources.devices.label',
      singular: 'resources.devices.singular',
      plural: 'resources.devices.plural',
    },
  },
  {
    name: 'orders',
    list: '/orders',
    show: '/orders/:id',
    meta: {
      label: 'resources.orders.label',
      singular: 'resources.orders.singular',
      plural: 'resources.orders.plural',
    },
  },
  {
    name: 'fraudProfiles',
    list: '/fraud-profiles',
    meta: {
      label: 'resources.fraudProfiles.label',
      singular: 'resources.fraudProfiles.singular',
      plural: 'resources.fraudProfiles.plural',
    },
  },
  {
    name: 'sims',
    list: '/sims',
    show: '/sims/:iccid',
    meta: {
      label: 'resources.sims.label',
      singular: 'resources.sims.singular',
      plural: 'resources.sims.plural',
    },
  },
  {
    name: 'subscriptions',
    list: '/subscriptions',
    meta: {
      label: 'resources.subscriptions.label',
      singular: 'resources.subscriptions.singular',
      plural: 'resources.subscriptions.plural',
    },
  },
  {
    name: 'cancellations',
    show: '/cancellations/:id',
    meta: {
      label: 'resources.cancellations.label',
      singular: 'resources.cancellations.singular',
      plural: 'resources.cancellations.plural',
    },
  },
  {
    name: 'customers',
    list: '/customers',
    show: '/customers/:id',
    meta: {
      label: 'resources.customers.label',
      singular: 'resources.customers.singular',
      plural: 'resources.customers.plural',
    },
  },
  {
    name: 'portabilities',
    list: '/portabilities',
    show: '/portabilities/:id',
    meta: {
      label: 'resources.portabilities.label',
      singular: 'resources.portabilities.singular',
      plural: 'resources.portabilities.plural',
    },
  },
  {
    name: 'changes',
    list: '/changes',
    show: '/changes/:id',
    meta: {
      label: 'resources.changes.label',
      singular: 'resources.changes.singular',
      plural: 'resources.changes.plural',
    },
  },
  {
    name: 'shipments',
    list: '/shipments',
    show: '/shipments/:id',
    meta: {
      label: 'resources.shipments.label',
      singular: 'resources.shipments.singular',
      plural: 'resources.shipments.plural',
    },
  },
  {
    name: 'externalApps',
    list: '/external-apps',
    meta: {
      label: 'resources.externalApps.label',
      singular: 'resources.externalApps.singular',
      plural: 'resources.externalApps.plural',
    },
  },
];
